export const CERTIFICATE_ACTIONS = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

export const DEFAULT_CERTIFICATE_FORM = {
  type: 'Document',
  subtype: 'Certificate',
  certificate: null,
  certificateType: null,
  certificateBody: null,
  certificateExpiryDate: null,
};

export const SUPPORT_COMMON_TYPES = [
  'jpeg',
  'png',
  'jpg',
  'tiff',
  'tif',
  'mp4',
  'mov',
  'avi',
  'mp3',
  'zip',
  'rar',
  'txt',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'bmp',
  'gif',
  'webm',
  'csv',
];
